// eslint-disable-next-line no-shadow
export enum CanvasAssetType {
	IMAGE = 'image',
	VIDEO = 'video',
	AUDIO = 'audio',
	TEXT = 'text',
}
